import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Icon from '../../../components/AppIcon';

const ActivityFeedItem = ({ activity }) => {
  const { t, currentLanguage } = useLanguage();

  const priorityConfig = {
    high: {
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    },
    medium: {
      icon: 'Info',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    low: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    normal: {
      icon: 'Bell',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    }
  };

  const config = priorityConfig?.[activity?.priority] || priorityConfig?.normal;

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return t('dashboard.justNow');
    if (diffMins < 60) return `${diffMins} ${t('dashboard.minutesAgo')}`;
    if (diffHours < 24) return `${diffHours} ${t('dashboard.hoursAgo')}`;
    return `${diffDays} ${t('dashboard.daysAgo')}`;
  };

  return (
    <div className={`flex gap-3 md:gap-4 p-3 md:p-4 rounded-lg border ${config?.borderColor} hover:bg-muted/50 transition-smooth`}>
      <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full ${config?.bgColor} flex items-center justify-center`}>
        <Icon name={config?.icon} size={20} className={config?.color} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-sm md:text-base font-medium text-foreground">
            {activity?.title}
          </p>
          <span className="caption text-muted-foreground flex-shrink-0">
            {formatTime(activity?.timestamp)}
          </span>
        </div>
        <p className="caption text-muted-foreground line-clamp-2 mb-2">
          {activity?.description}
        </p>
        {activity?.actionLabel && (
          <button className="caption text-primary hover:text-primary/80 font-medium transition-smooth">
            {activity?.actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default ActivityFeedItem;